import React, { useState } from "react";

type FAQItem = {
  q: string;
  a: string;
};

type FaqSectionProps = {
  title?: string;
  faqs: FAQItem[];
  maxWidth?: string;
};

const FaqSection: React.FC<FaqSectionProps> = ({
  title = "Frequently Asked Questions",
  faqs,
  maxWidth = "750px",
}) => {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <section className="pt-80 pb-80">
      <div className="container">
        {/* SECTION TITLE */}
        <h2 className="xb-section-title text-center wow fadeInUp">
          {title}
        </h2>

        {/* CENTER THE FAQ CONTENT */}
        <div
          className="mt-40 d-flex justify-content-center"
          style={{ width: "100%" }}
        >
          <div style={{ width: "100%", maxWidth }}>
            {faqs.map((f, i) => {
              const isOpen = openFAQ === i;

              return (
                <div
                  key={i}
                  className="wow fadeInUp xb-faq-wrapper"
                  data-wow-delay={`${i * 80}ms`}
                  style={{ marginBottom: "18px" }}
                >
                  {/* ----- FAQ CARD ----- */}
                  <div
                    onClick={() => setOpenFAQ(isOpen ? null : i)}
                    style={{
                      padding: "24px 28px",
                      borderRadius: "14px",
                      background: "rgba(255,255,255,0.06)",
                      border: "1px solid rgba(255,255,255,0.12)",
                      backdropFilter: "blur(10px)",
                      cursor: "pointer",
                      transition: "0.3s",
                    }}
                  >
                    {/* QUESTION ROW */}
                    <div className="d-flex justify-content-between align-items-center">
                      <h4
                        style={{
                          margin: 0,
                          fontSize: 18,
                          fontWeight: 600,
                          color: "#fff",
                        }}
                      >
                        {f.q}
                      </h4>

                      <span
                        style={{
                          fontSize: 28,
                          color: "#fff",
                          transform: isOpen
                            ? "rotate(45deg)"
                            : "rotate(0deg)",
                          transition: "0.25s",
                          fontWeight: 300,
                        }}
                      >
                        +
                      </span>
                    </div>

                    {/* ANSWER SECTION */}
                    <div
                      style={{
                        maxHeight: isOpen ? "200px" : "0px",
                        overflow: "hidden",
                        transition: "max-height 0.35s ease",
                      }}
                    >
                      <p
                        style={{
                          opacity: isOpen ? 1 : 0,
                          marginTop: isOpen ? 12 : 0,
                          transition: "opacity 0.25s ease",
                          color: "rgba(255,255,255,0.85)",
                          lineHeight: "1.6",
                        }}
                      >
                        {f.a}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
